import { MoreHoriz } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useState, type MouseEvent } from 'react'

export type TableActionMenuItem = {
  key: string
  label: string
  danger?: boolean
  disabled?: boolean
  onClick: () => void
}

type Props = {
  items: TableActionMenuItem[]
  ariaLabel: string
}

/** 行の操作メニュー(三点アイコン + ドロップダウン)。 */
export const TableActionMenu = ({ items, ariaLabel }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  if (items.length === 0) {
    return null
  }

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (event?: object) => {
    if (event instanceof MouseEvent) {
      event.stopPropagation()
    }
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton size="small" aria-label={ariaLabel} onClick={handleOpen}>
        <MoreHoriz fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items.map(item => (
          <MenuItem
            key={item.key}
            disabled={item.disabled}
            sx={item.danger ? { color: 'error.main' } : undefined}
            onClick={event => {
              event.stopPropagation()
              item.onClick()
              setAnchorEl(null)
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
